import React from 'react';
import s from './AuthorWidget.scss';

const AuthorWidget = ({ authorData }) => {
  const {
    personalprofile: { displayname = '', bio = '' } = {},
    image: { id = '', imgsize = '' } = {},
  } =
    authorData || {};
  let imageURL = 'https://static.toiimg.com/photo/10916308.cms';
  if (id) {
    imageURL = `https://timesofindia.indiatimes.com/authorphoto/${id}.cms?len=${imgsize}`;
  }
  return (
    <div className={s.aboutAuthor}>
      <div className={s.info}>
        <figure>
          <img src={imageURL} alt="author" />
        </figure>
      </div>
      <div className={s.details}>
        <h1>{displayname}</h1>
        <p>{bio}</p>
      </div>
    </div>
  );
};

AuthorWidget.defaultProps = {
  sectionData: {},
};
export default AuthorWidget;
